'use client';

import React from 'react';
import classNames from 'classnames';
import { Radio } from '@/design-system/components/Form/Radio/Radio';

export interface RadioOption {
  label: string;
  value: string;
}

export interface RadioGroupProps {
  name: string;
  options: RadioOption[];
  value: string | undefined;
  onChange: (value: string) => void;
  disabled?: boolean;
  direction?: 'horizontal' | 'vertical';
  className?: string;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  name,
  options,
  value,
  onChange,
  disabled = false,
  direction = 'vertical',
  className,
}) => {
  return (
    <div
      className={classNames(
        'flex gap-4',
        {
          'flex-col': direction === 'vertical',
          'flex-row flex-wrap': direction === 'horizontal',
        },
        className,
      )}
      role="radiogroup"
    >
      {options.map((option) => (
        <Radio
          key={option.value}
          name={name}
          value={option.value}
          label={option.label}
          selected={value === option.value}
          disabled={disabled}
          onChange={onChange}
        />
      ))}
    </div>
  );
};

export default RadioGroup;
